<div>
  {{ uiService.productName }} is no longer using the Elastic Disaster Recovery service to replicate the EC2 instance
  {{ ec2InstanceId }}.
</div>
<div class="margin-top">
  At this time, if you are no longer using Elastic Disaster Recovery with this instance, you can disconnect and delete
  the source server with ID {{ sourceServerId }} from within the Elastic Disaster Recovery console.
</div>
<div class="flex-center-row control-header">
  <div class="spacer"></div>
  <button
    busy-button
    [busy]="acknowledging"
    class="arpio-button"
    [disabled]="acknowledging"
    (click)="acknowledgeIssue()"
  >
    ACKNOWLEDGE
  </button>
</div>
